//
//
//
//
//
//
//
//
//
//
//
//


import CoolLightBox from "vue-cool-lightbox"
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {

    name: 'ProfileLightbox',

    components: { CoolLightBox },

    data() {
        return {
            galleryIndex: null,
            images: [],
        }
    },

    mounted() {

        this.$bus.$on('openDestinationGallery', this.openDestinationGallery)
        this.$bus.$on('openCompanyGallery', this.openCompanyGallery)

    },

    methods: {

        async getDestinationImages(id) {

            try {
                const response = await this.$store.dispatch('profile/GET_DESTINATION_IMAGES', id)
                this.images = response.data
                this.galleryIndex = 0
            } catch (e) {
                this.$logger.captureException(e)
            }

        },

        openDestinationGallery(id) {
            this.getDestinationImages(id)
        },

        openCompanyGallery(images, index) {
            this.images = images
            this.galleryIndex = index
        }

    },

    computed: {

        galleryItems() {

            if(!this.images.length) {
                return []
            }

            let images = []

            this.images.forEach(image => {
                images.push({
                    src: image.url,
                    thumb: image.urlThumb,
                    title: image.name,
                })
            })

            return images

        }

    }

}

